<div class="innerpage-fullwithbanner dashboardarea clearfix">
  <div class="left">
    <h2 class="bighead">My Portal</h2>
    <ul class="bread-crumbs">
      <li>My Portal</li>
    </ul>
  </div>
</div>
<div class="principle-dashboard-wrapper">
  <div class="container">
    <div class="row d-flex flex-wrap-wrap">
      <div class="col-lg-4 col-md-4">
        <div class="principle-box" *ngIf="IsMyPortfolioEnabled">
          <h2 class="mainhead mr-auto"><span class="text">My Portfolio</span></h2>
          <p>
            We're launching a whole new set of tools to help you manage your net lease investment
            portfolio online.
          </p>
          <div class="margin-top-auto" style="padding-top: 24px"><button (click)="OnClickPortfolio()" class="btn btn-success btn-lg btn-send-inquiry"> View My Portfolio </button></div>
          <!--<div style="padding-top: 37px"><button *ngIf="!userAddedToWaitList" (click)="AddToWishList()" class="btn btn-success btn-lg btn-send-inquiry"> Join the Waitlist </button></div>
          <div><button *ngIf="userAddedToWaitList" [disabled]="disbleWaitListButton" class="btn btn-success btn-lg btn-send-inquiry">  Added to Waitlist </button></div>-->
          <span class="icon-circle"><img src="assets/img/my-portfolio.png"></span>
        </div>
        <div class="principle-box" *ngIf="!IsMyPortfolioEnabled">
          <h2 class="mainhead mr-auto"><span class="text">My Portfolio</span></h2>
          <p>
            Get the latest portfolio management tools and build your portfolio! Add, manage and track your
            properties, files, contacts, see your tenants market performances and even add team members to manage properties!
          </p>
          <div class="margin-top-auto" style="padding-top: 24px"><button style ="background:#A7A8A9 !important" (click)="OnClickMyPortfolioAccess(RequestMyPortfolioAccess,'portfolio-bov-modal')" class="btn btn-success btn-lg btn-send-inquiry"> More About My Portfolio</button></div>
          <span class="icon-circle"><img src="assets/img/my-portfolio.png"></span>
        </div>
      </div>
      <div class="col-lg-4 col-md-4">
        <div class="principle-box">
          <h2 class="mainhead mr-auto"><span class="text">Seller Dashboard</span></h2>
          <p *ngIf="hasSellerDashboardAccess">
            View the latest buyer feedback, communicate with your B+E Broker, and track transaction progress
            for your B+E Listings
          </p>
          <p *ngIf="!hasSellerDashboardAccess">
            Use Seller Dashboard to track real-time buyer feedback and make data-driven decisions for all
            properties listed with B+E.
          </p>
          <div class="margin-top-auto" style="padding-top:24px" *ngIf="hasSellerDashboardAccess"><button id="btnViewSellerDashboard" (click)="sellerDashboardBtnClick()" class="btn btn-success btn-lg btn-send-inquiry"> View Seller Dashboard </button></div>
          <div class="margin-top-auto" style="padding-top: 24px " *ngIf="!hasSellerDashboardAccess"><button style="background:#A7A8A9 !important" id="btnsellerDashboardViewMore" (click)="sellerDashboardBtnClick()" class="btn btn-success btn-lg btn-send-inquiry"> More About Seller Dashboard </button></div>
          <span class="icon-circle"><img src="assets/img/list-with-ease.png"></span>
        </div>
      </div>
      <div class="col-lg-4 col-md-4">
        <div class="principle-box">
          <h2 class="mainhead mr-auto"><span class="text">1031 Trade</span></h2>

          <p>
            Browse the Net Lease Market, communicate with your B+E Broker, and stay on top of 1031
            deadlines.
          </p>
          <div class="margin-top-auto" style="padding-top: 24px" *ngIf="has1031DashboardAccess"><button id="btnView1031Dashboard" class="btn btn-success btn-lg btn-send-inquiry" (click)="principalDashboardBtnClick()"> View 1031 Trade </button></div>
          <div class="margin-top-auto" style="padding-top: 24px" *ngIf="!has1031DashboardAccess"><button style="background:#A7A8A9 !important" (click)="principalDashboardBtnClick()" class="btn btn-success btn-lg btn-send-inquiry"> More About 1031 Trade </button></div>
          <span class="icon-circle"><img src="assets/img/1031-trade.png"></span>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="container min-heightcontainer prin-dsh-btm">
  <div class="row margin-top-20" style="margin-top: 25px !important">
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
      <div class="border-div">
        <div class="d-flex chart-box-header margin-bottom-30 align-item-center">
          <h2 class="mainhead mr-auto"><span class="text">Featured Listings</span></h2>
        </div>
        <div class="col-xs-12">
          <div class="row d-flex be-feature-pro-listing justify-content-center">
            <div class="col-md-4 col-lg-3 col-sm-6 col-xs-6 fullwidth600" *ngFor="let item of properties">
              <be-property-card [property]="item" [isFromPrincipalDashboard]="true" (propertyPriorityChanged)="null"></be-property-card>
            </div>
          </div>
        </div>

        <div class="cf"></div>
        <div class="floatinghead clearfix" style="text-align:center">
          <button class="btn btn-success btn-lg btn-send-inquiry" (click)="router.navigate(['/propertylisting'])" style="margin-bottom: 30px">VIEW ALL LISTINGS</button>
        </div>
      </div>
    </div>
  </div>


  <div class="row">
    <div class="col-lg-4 calender-wrapper">
      <app-deal-calandar [sellerId]="sellerId" [isFromPrincipalDashboard]="true"></app-deal-calandar>
    </div>
    <div class="col-lg-4">
      <div class="featuredproperties section-margin">
        <div class="container container-lg min-heightcontainer be-twitter-feeds">
          <div class="row">
            <div class="col-lg-4 ">
              <div class="border-div list-box table-fixed margin0">
                <div class="tabstyle2 offerdetailstab-padding pos-relative" id="dashboard-insights">
                  <ul class="switchingproperty margin-bottom-15 offerlistingtab">
                    <li [class.active]="currentTab === tabs.RecentFeeds">
                      <a href="javascript:void(0);" (click)="onTabClick(tabs.RecentFeeds)">
                        Recent Feeds
                      </a>
                    </li>
                    <li [class.active]="currentTab === tabs.Insights">
                      <a href="javascript:void(0);" (click)="onTabClick(tabs.Insights)">
                        B + E Insights
                      </a>
                    </li>
                  </ul>
                </div>
                <div *ngIf="currentTab === tabs.RecentFeeds">
                  <div class="floatinghead clearfix">
                    <div class="rightside clearfix">
                      <div class="search-sec">
                        <div style="width:50%">
                          <iframe src='https://www.sociablekit.com/app/embed/71724' frameborder='0' width='100%' height='1000'></iframe>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div *ngIf="currentTab === tabs.Insights" class="main_wrapper">
                  <!--<div *ngFor="let insights of Insights" class="be-app-blog">
                    <a href="{{insights.link}}" target="_blank">
                      <img src="{{insights.featured_image_src}}"/>
                      <h5 class="blog-title">{{insights.formatted_title}}</h5>
                    </a>
                    <div class=""></div>
                    <div *ngFor="let cat of insights.insights_category_details">
                      <a href="{{cat.url}}" target="_blank" style="color: blue; padding-bottom: 10px">{{cat.name}}</a>
                    </div>
                    <div> | {{ insights.date ? (Validation.convertUTCDateToLocalDate(insights.date)| date:'MM/dd/yyyy') :'-' }}</div>
                    <div>{{insights.formatted_exceprt}}</div>
                  </div>-->
                  <ul class="news category_list">
                    <li *ngFor="let insights of Insights">
                      <div class="news-img">
                        <a href="{{insights.link}}" target="_blank">
                          <div class="blog_post_media">
                            <img src="{{insights.featured_image_src}}" />
                          </div>
                        </a>
                      </div>
                      <div class="news-text">
                        <span class="headinglink">
                          <span class="ns-title">
                            <a href="{{insights.link}}" target="_blank" class="headinglink">{{insights.formatted_title}}</a>
                          </span>
                          <span class="news-source inline-block">
                            <a href="{{cat.url}}" target="_blank" *ngFor="let cat of insights.insights_category_details">{{cat.name}}</a>
                          </span>
                          <span class="date">{{ insights.date ? (Validation.convertUTCDateToLocalDate(insights.date)| date:'MM/dd/yyyy') :'-' }}</span>
                        </span>
                        <p>{{insights.formatted_exceprt}}</p>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="col-lg-4">
      <div class="border-div intrest-div">
        <div class="d-flex chart-box-header margin-bottom-30 align-item-center" style="position:relative;">
          <h2 class="mainhead mr-auto"><span class="text">Submit your Acquisition Criteria</span></h2>
        </div>
        Never miss a deal! Let B+E know what types of net lease investment properties you’re looking
        for.
        <div style="padding-top: 15px"><button class="btn btn-success btn-lg btn-send-inquiry" (click)="InterestCriteriaBtnClick()">Set Criteria </button></div>
        <img src="../assets/img/ic-image.png" class="icm-img" />
      </div>
    </div>
  </div>

  <div class="clearfix"> </div>
  <div class="margin-bottom-30">
    <app-financial-news [sellerId]="sellerId" [SoucePage]="currentSourcePage"></app-financial-news>
  </div>

</div>

<ng-template #SellerDashboardNoAccess>
  <div class="modal-header" style="display: block">
    <h4 class="modal-title pull-left">Seller Dashboard</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modelRefSellerDashboard.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <app-seller-learn-more></app-seller-learn-more>
      <!--<iframe class="embed-responsive-item" src="assets/HTML/SellerDashboardLearnMore.html" frameBorder="0"></iframe>-->
    </div>
  </div>
</ng-template>

<ng-template #PrincipalDashboardNoAccess>
  <div class="modal-header" style="display: block">
    <h4 class="modal-title pull-left">1031 Trade</h4>
    <button type="button" class="close pull-right" aria-label="Close" (click)="modelRefSellerDashboard.hide()">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="form-group">
      <app-trade-learn-more></app-trade-learn-more>
      <!--<iframe class="embed-responsive-item" src="assets/HTML/1031TradePopup.html" frameBorder="0"></iframe>-->
    </div>
  </div>
</ng-template>
<ng-template #RequestMyPortfolioAccess>

  <div class="modal-header">
    <button type="button" class="close pull-right" aria-label="Close" (click)="modalMyPortfolioAccess.hide();">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>
  <div class="modal-body padding30">
    <div class="margin-bottom-30">
      <h4 style="font-weight:600;" class="d-flex align-item-center"> <img src="/assets/img/settings.png" /> <span class="margin-left-15">My Portfolio Is In Development!</span></h4>
    </div>
    <div class="row">
      <ul class="a">
        <li class="margin-bottom-10" style="list-style-type: disc;"><h5>Track Your Portfolio's Value With Real-Time Market Data</h5></li>
        <li class="margin-bottom-10" style="list-style-type: disc;"><h5>Manage Property Files & Contacts</h5></li>
        <li class="margin-bottom-10" style="list-style-type: disc;"><h5>Add Team Members And Collaborate</h5></li>
      </ul>
    </div>
    <div class="cf">
      <div class="col-md-12 graybox-subscribe margin-top-10">
        <div class="cf">
          <div class="col-sm-9">
            <h5 style="font-weight:600;">Stay Tuned For Release Updates</h5>
            <p class="margin-bottom-10">Subscribe To Stay Up To Date About Release Dates.</p>
          </div>
          <div class="col-sm-3">
            <a href="https://info.tradenetlease.com/subscribe" target="_blank" class="modal-subscribe btn btn-border btn-lg margin-top-10">Subscribe</a>
          </div>
        </div>
      </div>
    </div>
    <div class="text-right">
      <button class="btn btn-success btn-lg" *ngIf="!userAddedToWaitList" (click)="ApproveMyPortfolio();">Join the Waitlist</button>
      <button *ngIf="userAddedToWaitList" [disabled]="disbleWaitListButton" class="btn btn-success btn-lg btn-send-inquiry">  Added to Waitlist </button>
    </div>
  </div>
</ng-template>
